import React, { useState, useCallback } from "react";

import { useHistory, Link, Route, Switch } from "react-router-dom";

import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import AuthForm from "../components/homepage/authForm";

import HomeContent from "../components/homepage/homeContent";
import { useCollectionData } from "react-firebase-hooks/firestore";
import Search from "../components/app/search";

const HomePage = (props) => {
  const [authFormTrigger, setAuthFormTrigger] = useState(false);
  const [logInTrigger, setLogInTrigger] = useState(false);
  const [registerTrigger, setRegisterTrigger] = useState(false);
  const [searchGame, setSearchGame] = useState();

  const [gamesList] = useCollectionData(
    firebase.firestore().collection("gamesList")
  );

  const history = useHistory();

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      // User is not signed in.
      history.push("/app");
    }
  });

  const AuthFormToggle = useCallback(
    (trigged) => {
      setAuthFormTrigger(true);
      trigged(true);
    },
    [setAuthFormTrigger]
  );

  return (
    <>
      <header className="homeHeader">
        <Link to="">
          <h1>Mate</h1>
        </Link>

        <div>
          <button onClick={(e) => AuthFormToggle(setRegisterTrigger)}>
            S'inscrire
          </button>
          <button onClick={(e) => AuthFormToggle(setLogInTrigger)}>
            Se connecter
          </button>
        </div>
      </header>
      {authFormTrigger && (
        <AuthForm
          registerTrigger={registerTrigger}
          setRegisterTrigger={setRegisterTrigger}
          logInTrigger={logInTrigger}
          setLogInTrigger={setLogInTrigger}
          setAuthFormTrigger={setAuthFormTrigger}
        />
      )}
      <main>
        <Switch>
          {searchGame && (
            <Route path="/search">
              <Search
                searchGame={searchGame}
                gamesList={gamesList}
                disconnected={true}
                setAuthFormTrigger={setAuthFormTrigger}
                setLogInTrigger={setLogInTrigger}
              />
            </Route>
          )}
          <Route path="">
            <HomeContent
              setSearchGame={setSearchGame}
              setAuthFormTrigger={setAuthFormTrigger}
              setRegisterTrigger={setRegisterTrigger}
              setLogInTrigger={setLogInTrigger}
              gamesList={gamesList}
            />
          </Route>
        </Switch>
      </main>
    </>
  );
};

export default HomePage;
